import {HttpRequest} from '../../../settings/HttpRequest/HttpRequest';

export const ProyectoService = {
	Listar: (filtro, paginacion) => {
		let params = {
			filtro: {
				id_cat_proyecto: filtro.id_cat_proyecto || null,
				activo: (Number(filtro.activo) === 1 || Number(filtro.activo) === 0) ? Number(filtro.activo) : null,
			},
			paginacion: {
				total: paginacion.total || null,
				page: paginacion.page || null,
				limit: paginacion.limit || null
			}
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Proyecto_Datos', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Agregar: (form) => {
		let params = {
			proyecto: form.proyecto,
			descripcion: form.descripcion,
			abreviatura: form.abreviatura,
			activo: form.activo ? 1 : 0
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Proyecto_Guardar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Modificar: (form) => {
		let params = {
			id_cat_proyecto: form.id_cat_proyecto,
			proyecto: form.proyecto,
			descripcion: form.descripcion,
			abreviatura: form.abreviatura,
			activo: form.activo ? 1 : 0
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Proyecto_Modificar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Eliminar: (id_cat_proyecto) => {
		let params = {
			id_cat_proyecto: id_cat_proyecto
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Proyecto_Eliminar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	}
};
